export class AssignToEditorModel {
    public contributorId: string;
    public unixTimeStamp: number;
    public editors: Array<string>;

    constructor() {
        this.editors = new Array<string>();
    }
}
